import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { forkJoin, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../environments/environment';

@Injectable({ providedIn: 'root' })
export class TranslocoAppLoader implements TranslocoLoader {
  private http = inject(HttpClient);

  getTranslation(lang: string) {
    const cacheBuster = environment.production
      ? `?v=${environment.version || new Date().getTime()}`
      : `?t=${new Date().getTime()}`;

    return forkJoin({
      local: this.http
        .get<Translation>(`./assets/i18n/${lang}.json${cacheBuster}`)
        .pipe(catchError(() => of({}))),
      shared: this.http
        .get<Translation>(
          `./assets/shared/language-service/i18n/${lang}.json${cacheBuster}`
        )
        .pipe(catchError(() => of({}))),
    }).pipe(map(({ local, shared }) => ({ ...local, ...shared })));
  }
}
